<template>
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33341 1.66675L1.66675 8.33341"
      stroke="#153D49"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M1.66659 1.66675L8.33325 8.33341"
      stroke="#153D49"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
